// extracted by mini-css-extract-plugin
module.exports = {"component":"Post_component__H1o12","container":"Post_container__UTtnv","variant--featured":"Post_variant--featured__THZIY","contentWrapper":"Post_contentWrapper__UdXNq"};